/* VIBY mystery-discount pop-up.
   Four game styles: classic scratch, match 3, pick a jar, shake the jar.
   Every game ends on the same prize: a mystery discount whose code is
   emailed after sign-up, so the code is never on the page. */
(function () {
  var KEY = 'vibyScratch';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function store(get, val) {
    try { if (get) return JSON.parse(localStorage.getItem(KEY) || '{}'); localStorage.setItem(KEY, JSON.stringify(val)); }
    catch (e) { return {}; }
  }
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

  /* ---------- foil ---------- */
  function paintFoil(canvas, opts) {
    var box = canvas.parentNode.getBoundingClientRect(); if (!box.width) return null;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = box.width * dpr; canvas.height = box.height * dpr;
    var ctx = canvas.getContext('2d'); ctx.scale(dpr, dpr);
    var w = box.width, h = box.height, f = opts.foil || 'green';
    var stops = f === 'gold' ? ['#B8872C', '#E9C76E', '#F8E6A8', '#D9AE52', '#F1D488', '#A97A24']
      : f === 'green' ? ['#2F4322', '#4C6B2F', '#A8B86A', '#5F7A34', '#8A9A48', '#2F4322'] : null;
    if (stops) { var g = ctx.createLinearGradient(0, 0, w, h); stops.forEach(function (c, i) { g.addColorStop(i / (stops.length - 1), c); }); ctx.fillStyle = g; }
    else ctx.fillStyle = f;
    ctx.fillRect(0, 0, w, h);
    var sh = ctx.createLinearGradient(0, h, w, 0);
    sh.addColorStop(.35, 'rgba(255,255,255,0)'); sh.addColorStop(.5, 'rgba(255,255,255,.3)'); sh.addColorStop(.65, 'rgba(255,255,255,0)');
    ctx.fillStyle = sh; ctx.fillRect(0, 0, w, h);
    ctx.strokeStyle = 'rgba(255,255,255,.07)'; ctx.lineWidth = 1;
    for (var x = -h; x < w; x += 6) { ctx.beginPath(); ctx.moveTo(x, h); ctx.lineTo(x + h, 0); ctx.stroke(); }
    for (var i = 0; i < w * h / 90; i++) { ctx.fillStyle = 'rgba(255,255,255,' + (Math.random() * .5).toFixed(2) + ')'; ctx.fillRect(Math.random() * w, Math.random() * h, 1.3, 1.3); }
    if (opts.border !== false) { ctx.strokeStyle = 'rgba(255,255,255,.5)'; ctx.lineWidth = 2; ctx.setLineDash([6, 6]); ctx.strokeRect(8, 8, w - 16, h - 16); ctx.setLineDash([]); }
    if (opts.mark) { ctx.fillStyle = 'rgba(255,255,255,.85)'; ctx.font = '700 ' + Math.round(Math.min(w, h) * .32) + 'px system-ui, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(opts.mark, w / 2, h / 2 + 1); }
    ctx.globalCompositeOperation = 'destination-out'; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.lineWidth = Math.max(opts.brush || 30, w * .12);
    return ctx;
  }
  function scratchable(canvas, opts, onDone) {
    var ctx = paintFoil(canvas, opts); if (!ctx) return false;
    var drawing = false, last = null, done = false, t;
    function pos(e) { var b = canvas.getBoundingClientRect(), p = e.touches ? e.touches[0] : e; return { x: p.clientX - b.left, y: p.clientY - b.top }; }
    function dot(p) { ctx.beginPath(); if (last) { ctx.moveTo(last.x, last.y); ctx.lineTo(p.x, p.y); ctx.stroke(); } ctx.arc(p.x, p.y, ctx.lineWidth / 2, 0, Math.PI * 2); ctx.fill(); last = p; }
    function ratio() { var d = ctx.getImageData(0, 0, canvas.width, canvas.height).data, c = 0, n = 0; for (var i = 3; i < d.length; i += 64) { n++; if (d[i] < 40) c++; } return c / n; }
    function finish() { if (done) return; done = true; canvas.classList.add('is-gone'); onDone(); }
    canvas.__reveal = finish;
    function start(e) { if (done) return; drawing = true; last = null; if (opts.onStart) opts.onStart(); dot(pos(e)); e.preventDefault(); }
    function move(e) { if (!drawing || done) return; dot(pos(e)); e.preventDefault(); clearTimeout(t); t = setTimeout(function () { if (ratio() > (opts.need || .45)) finish(); }, 60); }
    function end() { if (!drawing) return; drawing = false; last = null; if (!done && ratio() > (opts.need || .45)) finish(); }
    canvas.addEventListener('mousedown', start); canvas.addEventListener('touchstart', start, { passive: false });
    if (opts.tap) canvas.addEventListener('click', finish);
    window.addEventListener('mousemove', move); canvas.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('mouseup', end); window.addEventListener('touchend', end);
    return true;
  }

  /* ---------- confetti (VIBY colours) ---------- */
  function burst(host) {
    if (reduce || !host) return;
    var cols = ['#3F5A2E', '#8A9A48', '#7A1F2B', '#C8A14A', '#F7F2E8', '#9B1C2E'];
    for (var i = 0; i < 28; i++) {
      var s = document.createElement('i'); s.className = 'vb-scr__bit';
      var a = Math.random() * Math.PI * 2, r = 90 + Math.random() * 120;
      s.style.cssText = '--x:' + Math.round(Math.cos(a) * r) + 'px;--y:' + Math.round(Math.sin(a) * r - 40) + 'px;--r:' + Math.round(Math.random() * 540) + 'deg;background:' + cols[i % cols.length] + ';animation-delay:' + (Math.random() * .12).toFixed(2) + 's';
      host.appendChild(s);
    }
    setTimeout(function () { host.querySelectorAll('.vb-scr__bit').forEach(function (b) { b.remove(); }); }, 1600);
  }

  function Game(root) {
    var d = root.dataset, game = d.game || 'classic', design = d.design === '1', demo = d.demo === '1', posted = d.posted === '1';
    var state = demo ? {} : (store(true) || {});
    var opened = false, lastFocus = null, built = false, won = false;
    var foil = getComputedStyle(root).getPropertyValue('--vb-scr-foil').trim() || 'green';

    function step(name) {
      root.querySelectorAll('[data-step]').forEach(function (s) { s.hidden = s.dataset.step !== name; });
      if (name === 'claim') setTimeout(function () { var i = root.querySelector('input[type=email]'); if (i && !demo) i.focus(); }, 60);
    }
    function win(after) {
      if (won) return; won = true;
      var area = root.querySelector('[data-game-area]');
      area.classList.add('is-won'); burst(area);
      if (!demo) { state.revealed = true; if (!design) store(false, state); }
      setTimeout(function () { step('claim'); }, after || 1300);
    }

    /* each game */
    var build = {
      classic: function () {
        var c = root.querySelector('[data-foil]'), hint = root.querySelector('[data-hint]');
        scratchable(c, { foil: foil, onStart: function () { hint.classList.add('is-gone'); } }, function () { hint.classList.add('is-gone'); win(1100); });
      },
      match3: function () {
        var tiles = [].slice.call(root.querySelectorAll('[data-tile]')), syms = [].slice.call(root.querySelectorAll('[data-sym]'));
        // three prize symbols + three different others, shuffled
        var deck = shuffle(['win', 'win', 'win', 'a', 'b', 'c']);
        var found = 0, open = 0;
        tiles.forEach(function (t, i) {
          var kind = deck[i], src = syms.filter(function (s) { return s.dataset.sym === kind; })[0];
          t.querySelector('[data-face]').innerHTML = src ? src.innerHTML : '';
          t.dataset.kind = kind;
          var c = t.querySelector('canvas');
          scratchable(c, { foil: foil, border: false, brush: 22, need: .5, mark: '?', tap: true }, function () {
            t.classList.add('is-open'); open++;
            if (kind === 'win') { found++; t.classList.add('is-hit'); }
            var cnt = root.querySelector('[data-count]'); if (cnt) cnt.textContent = found;
            if (found === 3) {
              tiles.forEach(function (o) { var oc = o.querySelector('canvas'); if (o.dataset.kind !== 'win' && !o.classList.contains('is-open')) { o.classList.add('is-open', 'is-dim'); if (oc && oc.__reveal) { oc.classList.add('is-gone'); } } });
              root.querySelector('[data-game-area]').classList.add('is-revealed');
              win(1600);
            }
          });
        });
        var all = root.querySelector('[data-reveal-all]');
        if (all) all.addEventListener('click', function () { tiles.forEach(function (t) { var c = t.querySelector('canvas'); if (c.__reveal) c.__reveal(); }); });
      },
      pick: function () {
        var jars = [].slice.call(root.querySelectorAll('[data-jar]'));
        jars.forEach(function (j) {
          j.addEventListener('click', function () {
            if (won) return;
            jars.forEach(function (o) { o.classList.toggle('is-picked', o === j); o.classList.toggle('is-other', o !== j); o.disabled = true; });
            setTimeout(function () { root.querySelector('[data-game-area]').classList.add('is-revealed'); win(1500); }, reduce ? 0 : 650);
          });
        });
      },
      slots: function () {
        var reels = [].slice.call(root.querySelectorAll('[data-reel]')), btn = root.querySelector('[data-spin]');
        var syms = [].slice.call(root.querySelectorAll('[data-sym]')).map(function (x) { return { k: x.dataset.sym, h: x.innerHTML }; });
        var winSym = syms.filter(function (x) { return x.k === 'win'; })[0], others = syms.filter(function (x) { return x.k !== 'win'; });
        var N = 18, H = 0;
        reels.forEach(function (r) {
          var strip = r.querySelector('[data-strip]'), html = '';
          for (var i = 0; i < N; i++) { var sym = i === N - 2 ? winSym : others[(i + Math.floor(Math.random() * 3)) % others.length]; html += '<div class="vb-scr__sym">' + sym.h + '</div>'; }
          strip.innerHTML = html;
        });
        if (!btn) return;
        btn.addEventListener('click', function () {
          if (won || btn.disabled) return; btn.disabled = true; btn.classList.add('is-pulled');
          reels.forEach(function (r, i) {
            var strip = r.querySelector('[data-strip]'), cell = strip.firstChild.getBoundingClientRect().height;
            var target = -(cell * (N - 2)) + (r.clientHeight - cell) / 2;
            strip.style.transition = reduce ? 'none' : 'transform ' + (1.3 + i * .45) + 's cubic-bezier(.15,.85,.25,1.04)';
            strip.style.transform = 'translateY(' + target + 'px)';
            setTimeout(function () { r.classList.add('is-stopped'); }, reduce ? 0 : (1300 + i * 450));
          });
          setTimeout(function () { root.querySelector('[data-game-area]').classList.add('is-revealed'); win(1600); }, reduce ? 50 : 2400);
        });
      },
      claw: function () {
        var box = root.querySelector('[data-claw-box]'), claw = root.querySelector('[data-claw]'), rope = root.querySelector('[data-rope]'), btn = root.querySelector('[data-drop]');
        var balls = [].slice.call(root.querySelectorAll('[data-ball]'));
        if (!box || !claw) return;
        var x = 0.5, dir = 1, moving = true, raf;
        function place() { claw.style.left = (x * 100) + '%'; }
        function tick() { if (!moving) return; x += dir * 0.006; if (x > .9) { x = .9; dir = -1; } if (x < .1) { x = .1; dir = 1; } place(); raf = requestAnimationFrame(tick); }
        if (!reduce) raf = requestAnimationFrame(tick); else place();
        btn.addEventListener('click', function () {
          if (won || btn.disabled) return; btn.disabled = true; moving = false; cancelAnimationFrame(raf);
          var bb = box.getBoundingClientRect(), best = balls[0], bd = 1e9;
          balls.forEach(function (b) { var r = b.getBoundingClientRect(), c = (r.left + r.width / 2 - bb.left) / bb.width, dd = Math.abs(c - x); if (dd < bd) { bd = dd; best = b; } });
          var br = best.getBoundingClientRect();
          x = (br.left + br.width / 2 - bb.left) / bb.width;
          claw.style.transition = 'left .35s ease'; place();
          var drop = br.top - bb.top - 34;
          var T = reduce ? 0 : 1;
          setTimeout(function () { rope.style.height = drop + 'px'; }, 380 * T);
          setTimeout(function () { claw.classList.add('is-closed'); best.classList.add('is-grabbed'); claw.appendChild(best); }, 1300 * T);
          setTimeout(function () { rope.style.height = '0px'; }, 1650 * T);
          setTimeout(function () { claw.style.transition = 'left .8s ease-in-out'; x = .08; place(); }, 2500 * T);
          setTimeout(function () { claw.classList.remove('is-closed'); best.classList.add('is-dropped'); }, 3400 * T);
          setTimeout(function () { root.querySelector('[data-game-area]').classList.add('is-revealed'); win(1600); }, 3900 * T + 50);
        });
      },
      shake: function () {
        var jar = root.querySelector('[data-shake]'), left = root.querySelector('[data-left]'), n = +(jar && jar.dataset.taps) || 3;
        if (!jar) return;
        jar.addEventListener('click', function () {
          if (won || n <= 0) return;
          n--; if (left) left.textContent = n;
          jar.classList.remove('is-shaking'); void jar.offsetWidth; jar.classList.add('is-shaking');
          if (n === 0) setTimeout(function () { jar.classList.add('is-open'); root.querySelector('[data-game-area]').classList.add('is-revealed'); win(1500); }, reduce ? 0 : 520);
        });
      }
    };
    function setup() { if (built) return; built = true; (build[game] || build.classic)(); }

    function open(force) {
      if (opened && !force) return; opened = true; lastFocus = document.activeElement;
      root.hidden = false; if (!demo) document.documentElement.classList.add('vb-scr-lock');
      requestAnimationFrame(function () { root.classList.add('is-open'); requestAnimationFrame(setup); });
      if (!design && !demo) { state.seen = Date.now(); store(false, state); }
    }
    function close() {
      root.classList.remove('is-open'); document.documentElement.classList.remove('vb-scr-lock');
      setTimeout(function () { root.hidden = true; }, 200);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    root.__open = open; root.__close = close;
    root.querySelectorAll('[data-scr-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
    var skip = root.querySelector('[data-skip]');
    if (skip) skip.addEventListener('click', function () {
      root.querySelectorAll('canvas').forEach(function (c) { if (c.__reveal) c.__reveal(); });
      var jar = root.querySelector('[data-jar]'); if (jar && !won) jar.click();
      var sj = root.querySelector('[data-shake]'); if (sj && !won) { sj.dataset.taps = 1; root.querySelector('[data-game-area]').classList.add('is-revealed'); sj.classList.add('is-open'); win(1200); }
      if ((game === 'classic' || game === 'slots' || game === 'claw') && !won) { root.querySelector('[data-game-area]').classList.add('is-revealed'); win(900); }
    });

    var form = root.querySelector('form') || root.closest('form');
    if (form) form.addEventListener('submit', function (e) {
      if (demo) { e.preventDefault(); step('code'); return; }
      state.claimed = true; if (!design) store(false, state);
    });

    if (posted) { step('code'); open(true); return; }
    if (demo) return;
    if (design) {
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(root)) open(true); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(root)) close(); });
      return;
    }
    var days = (+d.days || 14) * 864e5;
    if (state.claimed || (state.seen && Date.now() - state.seen < days)) return;
    if (+d.delay > 0) setTimeout(open, +d.delay * 1000);
    if (+d.scroll > 0) window.addEventListener('scroll', function onS() {
      var p = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;
      if (p >= +d.scroll) { window.removeEventListener('scroll', onS); open(); }
    }, { passive: true });
    if (d.exit === 'true') document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) open(); });
    document.addEventListener('click', function (e) { var t = e.target.closest && e.target.closest('[href="#viby-gift"],[data-open-gift]'); if (t) { e.preventDefault(); open(true); } });
  }
  function init() { document.querySelectorAll('[data-vb-scratch]').forEach(function (r) { if (!r.__vb) { r.__vb = 1; Game(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.VibyScratch = { init: init };
})();
